import type { MemoryTab } from "../types/memory";

export type AppUrlState =
  | { view: "home" }
  | { view: "memories"; tab: MemoryTab };

export function parseAppUrl(search: string): AppUrlState {
  const q = new URLSearchParams(
    search.startsWith("?") ? search.slice(1) : search
  );
  const view = q.get("view");
  const tabRaw = q.get("tab");

  const tabFromParam: MemoryTab =
    tabRaw === "birthday" ? "birthday" : "anniversary";

  if (view === "home") {
    return { view: "home" };
  }

  if (view === "memories") {
    return { view: "memories", tab: tabFromParam };
  }
  if (tabRaw === "birthday" || tabRaw === "anniversary") {
    return { view: "memories", tab: tabFromParam };
  }
  return { view: "home" };
}

export function serializeAppUrl(state: AppUrlState): string {
  if (state.view === "home") {
    return "?view=home";
  }
  return `?view=memories&tab=${state.tab}`;
}

export function replaceUrl(state: AppUrlState): void {
  const qs = serializeAppUrl(state);
  const path = `${window.location.pathname}${qs}${window.location.hash}`;
  window.history.replaceState(null, "", path);
}
